import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import CopyToClipboard from "react-copy-to-clipboard";

import copyIcon from "../../../assets/images/link_copy.svg";
import copyCode from "../../../assets/images/copy-icon.svg";

import ShareDocumentmodal from "./modal/ShareDocumentModal";
import shareadduser from "../../../assets/images/shareadduser.svg";
import InviteOnlyFormComponent from "./InviteOnlyFormComponent";
import { shareAccessToggle } from "../../../features/chatbot/shareAccessToggleSlice";
import { getProjectPermission } from "../../../features/project-permission/getProjectPermissionSlice";
import { generateJWT } from "../../../features/project-permission/generateJWTSlice";
import { isValidNumber } from "../../../utils/utils";

const ShareComponent = ({ subCategories }) => {
  const [publicShareChange, setPublicShareChange] = useState("");
  const [publicSharShow, setPublicShareShow] = useState(false);

  const [currentRadio, setCurrentRadio] = useState("");

  const [hourValue, setHourValue] = useState("");

  const [show, setShow] = useState(false);

  const [publicShare, setPublicShare] = useState(true);

  const [privateShareType, setPrivateShareType] = useState(1);

  const [passwordData, setPasswordData] = useState("");

  const [passwordErrorText, setPasswordErrorText] = useState("");

  const [jwtToken, setJWTToken] = useState("");

  const [jwtTokenErrorText, setJWTTokenErrorText] = useState("");

  const [inviteOnlyData, setInviteOnlyData] = useState([]);

  const { permissionData } = useSelector(
    (state) => state.getProjectPermissionReducer
  );

  const dispatch = useDispatch();

  /**
   * handle public share link change function
   * @param {*} e
   */
  const handlePublicShareChange = (e) => {
    setCurrentRadio("publicCheck");
    setPublicShareShow(true);
  };

  /**
   * handle share password change function
   * @param {*} e
   */
  const handleSharePasswordChange = (e) => {
    setCurrentRadio("passWordCheck");
    setPublicShareShow(false);
  };

  /**
   * handle jwt generate function
   * @param {*} e
   */
  const handleJWTChange = (e) => {
    setCurrentRadio("jwtCheck");
    setPublicShareShow(false);
  };

  useEffect(() => {
    if (subCategories === "share")
      dispatch(
        getProjectPermission(
          JSON.parse(localStorage.getItem("_user")).projects[0].uuid
        )
      );
  }, []);

  useEffect(() => {
    if (
      permissionData?.is_public !== null &&
      permissionData?.is_public !== undefined
    ) {
      if (
        permissionData?.is_public === 2 ||
        permissionData?.is_public === 3 ||
        permissionData?.is_public === 4
      ) {
        setPrivateShareType(permissionData?.is_public);
        setPublicShare(false);
        if (permissionData?.is_public === 3) {
          setHourValue(
            parseInt(
              permissionData?.token_expire_time &&
              permissionData?.token_expire_time
            )
          );
          setJWTToken(permissionData?.token);
        } else if (permissionData?.is_public === 4) {
          setInviteOnlyData(permissionData);
        } else {
          setPasswordData(permissionData?.password && permissionData?.password);
        }
      } else {
        setPublicShare(true);
      }
    }
  }, [permissionData]);

  useEffect(() => {
    setTimeout(() => {
      setShow("");
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const setPermission = async () => {
    if (privateShareType === 1) {
      const { payload } = await dispatch(
        shareAccessToggle({
          _toggleKey: privateShareType,
          project_slug_name: JSON.parse(localStorage.getItem("_user"))[
            "projects"
          ][0]["slug"],
        })
      );
    }
    if (privateShareType === 2) {
      if (passwordData === "") {
        setPasswordErrorText("Password cannot be blank!");
      } else if (
        passwordData.match(
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{8,32}$/
        )
      ) {
        const { payload } = await dispatch(
          shareAccessToggle({
            _toggleKey: privateShareType,
            project_slug_name: JSON.parse(localStorage.getItem("_user"))[
              "projects"
            ][0]["slug"],
            password: passwordData,
          })
        );
      } else {
        setPasswordErrorText(
          "Password should contains 8-32 characters. At least 1 digit, 1 special character, 1 uppercase letter & 1 lowercase letter."
        );
      }
    }
    if (privateShareType === 3) {
      if (hourValue === "") {
        setJWTTokenErrorText("Please enter hours.");
      } else {
        if (jwtToken !== "") {
          const { payload } = await dispatch(
            shareAccessToggle({
              _toggleKey: privateShareType,
              project_slug_name: JSON.parse(localStorage.getItem("_user"))[
                "projects"
              ][0]["slug"],
              token_expires_at: hourValue.toString() + "h",
              jwt_token: jwtToken,
            })
          );
        } else {
          setJWTTokenErrorText("Please generate JWT");
        }
      }
    }
  };

  const generatejwt = async () => {
    if (hourValue === "") {
      setJWTTokenErrorText("Please enter hours.");
    } else {
      setJWTTokenErrorText("");
      const { payload } = await dispatch(
        generateJWT({
          slug: JSON.parse(localStorage.getItem("_user")).projects[0].slug,
          token_expires_at: hourValue.toString() + "h",
        })
      );
      setJWTToken(payload.data.responseData.token);
    }
  };

  return (
    <>
      <div className="sub-title mt-0 mt-md-4 mb-3 pb-md-2">
        Project Level Permission
      </div>
      <div className="share-block-main">
        <div className="share-form-check">
          <div className="d-flex justify-content-between copy-input form-group">
            <div className="form-group w-100 mb-0">
              <input
                type="text"
                placeholder="Enter Link"
                name="label"
                className="form-control sharing-control"
                value={`${process.env.REACT_APP_IFRAME_BASEURL}/${JSON.parse(localStorage.getItem("_user"))["projects"][0][
                  "slug"
                  ]
                  }`}
                onChange={() => { }}
              />
            </div>
            <CopyToClipboard
              text={`${process.env.REACT_APP_IFRAME_BASEURL}/${JSON.parse(localStorage.getItem("_user"))["projects"][0]["slug"]
                }`}
              onCopy={() => {
                setShow(true);
              }}
            >
              <button className="btn copy-btn">
                {" "}
                <img src={copyIcon} alt="copy" />
                <div
                  className={
                    !show ? `chat-tooltip-inner d-none` : `chat-tooltip-inner `
                  }
                >
                  copied!!
                </div>
              </button>
            </CopyToClipboard>
          </div>
          <div className="form-group">
            {/* <div className="form-control code-text">
              <pr className="embed-code">
                <span>&lt;</span>!DOCTYPE html<span>&gt;</span>
                <span>&lt;</span>html<span>&gt;</span>
                <span>&lt;</span>head<span>&gt;</span>
                <span>&lt;</span>title<span>&gt;</span>A Meaningful Page Title
                <span>&lt;</span>/title<span>&gt;</span>
                <span>&lt;</span>/head<span>&gt;</span>
                <span>&lt;</span>body<span>&gt;</span>
                The content of the document......
                <span>&lt;</span>/body<span>&gt;</span>
                <span>&lt;</span>/html<span>&gt;</span>
              </pr>

              <span className=" copy-code-btn">
                <img src={copyCode} alt="copy" />
                <div
                  className={
                    !show ? `chat-tooltip-inner d-none` : `chat-tooltip-inner `
                  }
                >
                  copied!!
                </div>
              </span>
            </div> */}
          </div>
          <div className="form-group">
            <div className="form-check d-inline-block me-3 mb-0">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault1"
                onChange={() => {
                  setPublicShare(true);
                  setPrivateShareType(1);
                  setPasswordErrorText("");
                  setJWTTokenErrorText("");
                }}
                checked={publicShare ? true : false}
                defaultChecked={privateShareType}
              // onChange={() => { }}
              />
              <label
                className="form-check-label mb-0"
                htmlFor="flexRadioDefault1"
              >
                Public
              </label>
            </div>
            <div className="form-check d-inline-block mb-0">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault2"
                onChange={() => {
                  setPublicShare(false);
                  setPrivateShareType(2);
                  setPasswordErrorText("");
                  setJWTTokenErrorText("");
                }}
                checked={publicShare ? false : true}
              // onChange={() => { }}
              />
              <label
                className="form-check-label mb-0"
                htmlFor="flexRadioDefault2"
              >
                Private
              </label>
            </div>
          </div>
          {/* <div className="form-check">
                    <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked={"publicCheck" === currentRadio} onChange={(e) => { handlePublicShareChange(e) }} />
                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                        <div className="radio-label-div">
                            <p>Share it publicly</p>
                            <p>Any one who has this URL can chat</p>
                        </div>
                    </label>
                    {publicSharShow === true &&
                        <div className="d-flex justify-content-between copy-input">
                            <div className="form-group w-100 mb-0">
                                <input
                                    type="text"
                                    placeholder="Enter Link"
                                    name="label"
                                    className="form-control sharing-control"
                                    onChange={(e) => { setPublicShareChange(e.target.value) }}
                                />
                            </div>
                            <CopyToClipboard text={publicShareChange}>
                                <button className="btn copy-btn">
                                    <img src={copyIcon} alt="copy" />
                                </button>
                            </CopyToClipboard>
                        </div>}
                </div> */}
          {!publicShare && (
            <div className="share-link-box">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="privateShare"
                  id="privateSharedPassword"
                  checked={privateShareType === 2 ? true : false}
                  onChange={() => {
                    // handleSharePasswordChange();
                    {
                      setPrivateShareType(2);
                      setJWTTokenErrorText("");
                    }
                  }}
                  defaultChecked
                />
                <label
                  className="form-check-label"
                  htmlFor="privateSharedPassword"
                >
                  <div className="radio-label-div">
                    <p>
                      Requires a{" "}
                      <strong className="fw-600">shared password</strong> (or
                      secret link)
                    </p>
                    <p>Any one who has this URL can chat</p>
                  </div>
                </label>
                {privateShareType === 2 && (
                  <>
                    <div className="d-flex justify-content-between">
                      <div className="form-group w-100 mb-0">
                        <input
                          type="text"
                          placeholder="Shared Password"
                          name="label"
                          value={passwordData}
                          onChange={(e) => {
                            setPasswordData(e.target.value);
                            setPasswordErrorText("");
                          }}
                          className="form-control share-pas"
                        />
                      </div>
                    </div>
                    <p className="text-start text-danger text-break mb-2 mt-2">
                      {passwordErrorText && passwordErrorText}
                    </p>
                  </>
                )}
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="privateShare"
                  id="jwtShared"
                  checked={privateShareType === 3 ? true : false}
                  onChange={() => {
                    // handleSharePasswordChange();
                    {
                      setPrivateShareType(3);
                      setPasswordErrorText("");
                    }
                  }}
                />
                <label className="form-check-label" htmlFor="jwtShared">
                  <div className="radio-label-div">
                    <p>Requires a JWT (JSON Web Token) for SSO</p>
                    <p className="share-form-color-gray">
                      Write code on your server to generate a unique JWT for
                      each user.
                    </p>
                  </div>
                </label>
                {privateShareType === 3 && (
                  <>
                    <div className="d-flex justify-content-between">
                      <div className="form-group w-100 mb-0 d-flex align-items-center">
                        <input
                          type="text"
                          placeholder="24"
                          name="label"
                          value={hourValue}
                          onChange={(e) => {
                            if (isValidNumber(e.target.value)) {
                              setHourValue(e.target.value);
                              setJWTToken("");
                              setJWTTokenErrorText("");
                            }
                          }}
                          maxLength={2}
                          className="form-control share-generate"
                        />
                        <button
                          type="button"
                          className="btn ms-2"
                          onClick={() => generatejwt()}
                        >
                          Generate
                        </button>
                      </div>
                    </div>
                    {jwtToken && (
                      <p className="small-share-txt text-break">
                        {`${process.env.REACT_APP_IFRAME_BASEURL}/${JSON.parse(localStorage.getItem("_user"))[
                          "projects"
                          ][0]["slug"]
                          }?${jwtToken}`}
                      </p>
                    )}
                    <p className="text-start text-danger text-break mb-2 mt-2">
                      {jwtTokenErrorText && jwtTokenErrorText}
                    </p>
                  </>
                )}
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="privateShare"
                  id="flexRadioDefault4"
                  checked={privateShareType === 4 ? true : false}
                  onChange={() => {
                    setPrivateShareType(4);
                  }}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault4">
                  <div className="d-flex align-items-start flex-md-row flex-column">
                    <div className="radio-label-div pe-md-3">
                      <p>Invite-Only</p>
                      <p>
                        Only people who are explicitly invited can see this project.
                      </p>
                    </div>
                    {/* <button type="submit" className="btn ms-0 mt-3 ms-md-5 mt-md-1" onClick={inviteOnlySubmit}>
                      <img src={shareadduser} alt="shareadduser" className="sh-invite-img" />
                      Start Inviting
                    </button> */}
                  </div>
                </label>
                {privateShareType === 4 && (
                  <InviteOnlyFormComponent
                    setPublicShareShow={setPublicShareShow}
                    setCurrentRadio={setCurrentRadio}
                    currentRadio={currentRadio}
                    inviteOnlyData={inviteOnlyData}
                  />
                )}
                {privateShareType !== 4 && (
                  <div className="text-end">
                    <button
                      type="button"
                      className="btn btn-primary-md"
                      onClick={() => setPermission()}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
          {publicShare && (
            <div className="text-end">
              <button
                type="button"
                className="btn btn-primary-md"
                onClick={() => setPermission()}
              >
                Save
              </button>
            </div>
          )}

          {/*  <div className="form-check">
                    <input className="form-check-input" type="radio" onChange={(e) => { handleInviteChange(e) }} name="flexRadioDefault" id="flexRadioDefault4" />
                    <label className="form-check-label" htmlFor="flexRadioDefault4">
                        <div className="d-flex align-items-start flex-md-row flex-column">
                            <div className="radio-label-div pe-md-3">
                                <p>Invite-Only</p>
                                <p>
                                    Only people who are explicitly invited can see this project.
                                </p>
                            </div>
                            <button type="button" className="btn ms-0 mt-3 ms-md-5 mt-md-1">
                                <img src={shareadduser} alt="shareadduser" className="sh-invite-img" />
                                Start Inviting
                            </button>
                        </div>
                    </label>
                    {inviteChange === true &&
                        (<>
                            <div className="radio-label-div pe-md-3 pt-2 pt-md-2">
                                <p className='fw-500'>Permissions</p>
                            </div>

                            <div className='share-react-slect mt-1 pt-md-1'>
                                <div className='d-flex flex-column flex-md-row'>
                                    <div className='spcify-doc cmn-doc-slect'>
                                        <div className='radio-label-div'>
                                            <p>Entity</p>
                                        </div>
                                        <Select
                                            id="inputGroupSelect01"
                                            name="entity"
                                            options={EntireProject}
                                            value={permissionEntity}
                                            onChange={(e) => { handleEntityChange(e) }}
                                            placeholder="Select Entity"
                                            classNamePrefix="cmn-control"
                                        // menuIsOpen={true}
                                        />
                                    </div>
                                    <div className='first-pro cmn-doc-slect'>
                                        <div className='radio-label-div' onClick={() => { setCurrentModal("shareDocumentModal") }}>
                                            <p>Name</p>
                                        </div>
                                        <Select
                                            id="inputGroupSelect01"
                                            name="language"
                                            options={EntireProject}
                                            value={{ label: "My First Project", value: "My First Project", }}

                                            placeholder="My First Project"
                                            classNamePrefix="cmn-control"
                                        // menuIsOpen={true}
                                        />
                                    </div>
                                    <div className='access-dropdown cmn-doc-slect'>
                                        <div className='radio-label-div'>
                                            <p>Access</p>
                                        </div>
                                        <Select
                                            id="inputGroupSelect01"
                                            name="language"
                                            options={AcessName}
                                            value={{ label: "AcessName", value: "AcessName", }}
                                            placeholder="My First Project"
                                            classNamePrefix="cmn-control"
                                        // menuIsOpen={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>)}

                </div> */}
        </div>
      </div>
    </>
  );
};

export default ShareComponent;
